import React, { ReactElement, useState, useEffect, useCallback } from "react";
import { ViCoreCarModel } from "../models";
import { makeStyles, Theme, Paper, Typography } from "@material-ui/core";
import { Translator } from "../services";

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    gridArea: "makeModel",
    display: "flex",
    flexFlow: "column nowrap",
    placeContent: "center",
    placeItems: "center",
    padding: "0.382rem",
    paddingLeft: "0.618rem",
  },
  glasscar: ({ glasscarLoaded }: { glasscarLoaded: Boolean }) => ({
    transition: "all 0.146s ease-out",
    width: `${theme.goldenRatio(5)}rem`,
    pointerEvents: "none",
    userSelect: "none",
  }),
  text: { padding: `${theme.goldenRatio(-2)}rem ${theme.goldenRatio(0)}rem` },
  vehicleMake: ({ glasscarLoaded }: { glasscarLoaded: Boolean }) => ({
    transition: "all 0.146s ease-out",
    color: theme.palette.text.primary,
    fontWeight: "bold",
    fontSize: "1.1rem",
  }),
  vehicleModel: ({ glasscarLoaded }: { glasscarLoaded: Boolean }) => ({
    transition: "all 0.146s ease-out",
    color: theme.palette.text.secondary,
    fontSize: "1.1rem",
    // marginLeft: glasscarLoaded ? "0.236rem" : "0",
    ...(!glasscarLoaded ? { display: "block" } : {}),
  }),
}));

function MakeModelCard({
  carModel,
  isLoading,
}: {
  carModel: ViCoreCarModel | undefined;
  isLoading: Boolean;
}): ReactElement | null {
  const [glasscarPath, setGlasscarPath] = useState<string | undefined>();
  const [glasscarLoaded, setGlasscarLoaded] = useState<boolean>(false);
  const classes = useStyles({ glasscarLoaded });

  const loadGlasscar = useCallback((glasscarCode) => {
    return import(`../ui/glasscars/${glasscarCode}.png`).then((image) => {
      setGlasscarPath(image.default);
    });
  }, []);

  useEffect(() => {
    if (carModel) {
      const glasscarCode = Translator.translate(
        `carModels.${carModel.model.axManufacturerCodeInt}${carModel.model.axModelCodeInt}.GenGC01`,
        ""
      );
      if (glasscarCode) loadGlasscar(glasscarCode);
    }
  }, [carModel, loadGlasscar]);

  const { make, model } =
    (carModel &&
      carModel.model.axManufacturerCodeInt &&
      carModel.model.axModelCodeInt &&
      (Translator.translate(
        `carModels.${carModel.model.axManufacturerCodeInt}${
          carModel.model.axModelCodeInt || "00"
        }`,
        { returnObjects: true }
      ) as any)) ||
    {};

  return (
    <>
      <Paper elevation={3} className={classes.wrapper}>
        {glasscarPath !== undefined && (
          <img
            alt={"car model"}
            src={glasscarPath}
            className={classes.glasscar}
            onLoad={() => setGlasscarLoaded(true)}
          />
        )}
        {make ? (
          <Typography className={classes.text}>
            <span className={classes.vehicleMake}>{make}</span>
            {model ? <span className={classes.vehicleModel}>{` ${model}`}</span> : null}
          </Typography>
        ) : null}
      </Paper>
    </>
  );
}

export default MakeModelCard;
